import { Component, Injectable, Input, Output, EventEmitter } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct, NgbCalendar, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { FieldType } from '@ngx-formly/core';
import { ConfigService } from '@core/Abstract/config.service';

const I18N_VALUES = {
  'el': {
    weekdays: ['Δε', 'Τρ', 'Τε', 'Πέ', 'Πα', 'Σά', 'Κυ'],
    months: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μάι', 'Ιούν', 'Ιούλ', 'Αύγ', 'Σεπ', 'Όκτ', 'Νοέ', 'Δεκ'],
  }, 'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  },
};

@Injectable()
export class I18n {
  language = 'en';
}
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n, private translate: TranslateService, public config: ConfigService) {
    super();
    this._i18n.language = this.config.getCurrentLocaleStr();
    this.translate
      .stream('ALL_LOCATIONS_TREEVIEW')
      .subscribe(v => { this._i18n.language = this.translate.currentLang });
  }
  getWeekdayLabel(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? ((date.day < 10 ? '0' : '') + date.day)  + this.DELIMITER + ((date.month < 10 ? '0' : '') + date.month) + this.DELIMITER + date.year : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '-';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? ((date.day < 10 ? '0' : '') + date.day) + this.DELIMITER + ((date.month < 10 ? '0' : '') + date.month) + this.DELIMITER + date.year : '';
  }
}
@Component({
  selector: 'formly-field-date',
  template: `
  <div class="mb-1">
  <label>{{to?.label }}
    <span *ngIf="to?.required"> *</span>
  </label>
  <div class="row p-0 m-0 ">
    <input class="form-control col-md-10" type="text" [placeholder]="to?.innerLabel" name="d" [formControl]="formControl" [formlyAttributes]="field" ngbDatepicker #d="ngbDatepicker" />
    <div class="col-md-2">
      <div class="btn btn-primary pr-1 pl-1 pb-0 pt-0" (click)="d.toggle();">
        <i class="mdi mdi-calendar mdi-24px"></i>
      </div>
    </div>
    <div *ngIf="to?.description" style="color: red; font-weight: bold;">{{ to?.description }}</div>
    <div *ngIf="form.get(key).touched">
      <div *ngIf="formControl?.errors?.required" style="color: red;">{{ 'GENERIC.REQUIRED' | translate }}</div>
      <div *ngIf="formControl?.errors?.ngbDate?.invalid" style="color: red;">{{ 'GENERIC.INVALIDDATE' | translate }}</div>
    </div>
  </div>
</div>`,
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: NgbDateAdapter, useClass: CustomAdapter }
  ]
})
export class FormlyFieldDate extends FieldType { }